export const THEME_COLORS = {
  stone: {
    100: 'rgba(176, 177, 184, 0.10)',
    200: 'rgba(144, 145, 162, 0.20)',
    300: 'rgba(95, 98, 119, 0.30)',
    400: 'rgba(17, 21, 54, 0.40)',
    500: 'rgba(14, 17, 46, 0.50)',
    600: 'rgba(15, 19, 46, 0.60)',
    700: 'rgba(16, 19, 40, 0.70)',
    800: 'rgba(16, 19, 39, 0.80)',
    900: 'rgba(19, 21, 35, 0.90)'
  },
  blue: {
    100: '#eef1ff',
    200: '#ccdaff',
    300: '#a3bdff',
    400: '#7199ff',
    500: '#536cf1',
    600: '#354dcc',
    700: '#2439a6',
    800: '#142580',
    900: '#08134d'
  },
  gray: {
    100: '#fbfcfc',
    200: '#e6e7eb',
    300: '#cbccd4',
    400: '#9c9ead',
    500: '#848796',
    600: '#6c6f80',
    700: '#545666',
    800: '#3e404f',
    900: '#2b2c38'
  },
  red: {
    100: '#fee2e2',
    200: '#fecaca',
    300: '#fca5a5',
    400: '#f65f5f',
    500: '#ef4444',
    600: '#dc2626',
    700: '#b91c1c',
    800: '#991b1b',
    900: '#7f1d1d'
  },
  yellow: {
    100: '#fef3c7',
    200: '#fde68a',
    300: '#fcd34d',
    400: '#fbbf24',
    500: '#f59e0b',
    600: '#d97706',
    700: '#b45309',
    800: '#92400e',
    900: '#78350f'
  },
  orange: {
    100: '#ffedd5',
    200: '#fed7aa',
    300: '#fdba74',
    400: '#fb923c',
    500: '#f97316',
    600: '#ea580c',
    700: '#c2410c',
    800: '#9a3412',
    900: '#7c2d12'
  },
  purple: {
    100: '#f3e8ff',
    200: '#e9d5ff',
    300: '#d8b4fe',
    400: '#c084fc',
    500: '#a855f7',
    600: '#9333ea',
    700: '#7e22ce',
    800: '#6b21a8',
    900: '#581c87'
  },
  green: {
    100: '#f4fde8',
    200: '#f4fde8',
    300: '#cfe593',
    400: '#b8d95f',
    500: '#a3cc31',
    600: '#8cb222',
    700: '#6e8f11',
    800: '#516618',
    900: '#2d380e'
  },
  pink: {
    100: '#fce7f3',
    200: '#fbcfe8',
    300: '#f9a8d4',
    400: '#f472b6',
    500: '#ec4899',
    600: '#db2777',
    700: '#be185d',
    800: '#9d174d',
    900: '#831843'
  }
} as const
